
import { CodeNext, serializeFusionError } from "@fusion-advantage/backcompat"
import { DashboardLoadItemStatus, StatusedTodo, StatusedAppointment } from "./DashboardList"
import { ServiceAppointmentStatus, Todo, WorkItemType } from "./WorkItem"
import { BranchDesignator } from '@fusion-advantage/backcompat'
import { DisplayExport } from "../persistence/DisplayExport"

type FpoStatusedTodo = StatusedTodo & {
	dexp?: DisplayExport
}

type FpoStatusedAppt = StatusedAppointment & {
	dexp?: DisplayExport
}

export const FpoStatusedTodo0Item: Todo = {
	WorkItemType: WorkItemType.Todo,
	MemberGUID: 'D2EE6460-3859-4109-8D9E-1042BBE0F97A',
	MemberName: 'Eggbs Noodlefish',
	EncounterGUID: 'FC43D16B-E842-479B-981C-95B623633E38',
	CodeNext: CodeNext.InProgress,
	CreatedOn: '2025-08-08',
	ReadOnly: false,
}

export const FpoStatusedTodo1Item: Todo = {
	WorkItemType: WorkItemType.Todo,
	MemberGUID: '184D5529-4E0C-4C43-B292-411C03AECF5C',
	MemberName: 'Snorby Boboworthy',
	EncounterGUID: '1FE2CF3D-CF93-4052-898A-0BBA3B242D54',
	CodeNext: CodeNext.InProgress,
	CreatedOn: '2025-08-08',
	ReadOnly: false,
}

export const FpoStatusedTodos: FpoStatusedTodo[] = [
	{
		type: WorkItemType.Todo,
		status: DashboardLoadItemStatus.Ready,
		item: FpoStatusedTodo0Item,
		dexp: {
			encounterGuid: 'FC43D16B-E842-479B-981C-95B623633E38',
			codeNext: CodeNext.InProgress,
			branchGuid: '74D1CB4B-F3C2-49F5-A971-DC9083084B5A',
			branchDesignator: BranchDesignator.InHome,
			dateOfService: '2025-08-09',
			memberAge: 57,
			clientName: 'XYZ Insurance Co.',
			lastUpdateDt: '2025-08-09 16:41:34',
			auditorUsername: null,
			lineOfBusiness: 'N/A',
		},
	},
	{
		type: WorkItemType.Todo,
		status: DashboardLoadItemStatus.Ready,
		item: FpoStatusedTodo1Item,
		dexp: {
			encounterGuid: '1FE2CF3D-CF93-4052-898A-0BBA3B242D54',
			codeNext: CodeNext.InProgress,
			branchGuid: '74D1CB4B-F3C2-49F5-A971-DC9083084B5A',
			branchDesignator: BranchDesignator.VideoVisit,
			dateOfService: '2025-08-09',
			memberAge: 83,
			clientName: 'XYZ Insurance Co.',
			lastUpdateDt: '2025-08-09 16:41:34',
			auditorUsername: null,
			lineOfBusiness: 'N/A',
		},
	},
	{
		type: WorkItemType.Todo,
		status: DashboardLoadItemStatus.Error,
		itemKey: {
			type: WorkItemType.Todo,
			encounterGuid: '1FE2CF3D-CF93-4052-898A-0BBA3B242D54'
		},
		error: serializeFusionError('test error', 'test error 123'),
	},
]

export const FpoStatusedAppts: FpoStatusedAppt[] = [
	{
		type: WorkItemType.Appointment,
		status: DashboardLoadItemStatus.Ready,
		item: {
			WorkItemType: WorkItemType.Appointment,
			ServiceAppointmentID: '0001',
			AppointmentNumber: 'SA-0001',
			MemberGUID: '5B8AA475-0930-4063-BD1E-F39FAA4081B9',
			MemberName: 'Cummerata Jacques',
			MemberPhones: [
				{
					Label: 'Mobile',
					Number: '702-867-5309',
				},
				{
					Label: 'Secondary',
					Number: '612-555-2422',
				},
				// for dashboard display,
				// this one will get cut off by the first two
				{
					Label: 'Alternate',
					Number: '702-867-5309',
				},
			],
			StartTime: '2024-02-22T18:45:00.000Z',
			EndTime: '2024-02-22T20:00:00.000Z',
			Street: '430 S Western Ave',
			City: 'Los Angeles',
			State: 'CA',
			PostalCode: '90020',
			Country: 'United States',
			Latitude: 34.06617,
			Longitude: -118.30880,
			EstimatedTravelTimeMins: 15,
			CanTrustGPS: false,
			Status: ServiceAppointmentStatus.Dispatched,
			IsJoinable: true,
			HasInterpreter: true,
			InterpreterNumber: 'Ligula in finibus congue 702-867-5309',
			ClinicianNotes: 'Praesent dapibus vel quisque aliquet at bibendum odio nam dictum elit finibus eu consectetur. Tellus neque ut mi erat facilisis. Pharetra sodales per ultricies mattis diam quis dapibus tempus class cursus gravida. Varius sem dapibus lacinia cursus velit justo porttitor non proin. Mattis sagittis a scelerisque congue metus duis nisi lacinia dui.',
			EligibleLabs: ['LAB1', 'LAB2'],
			BranchDesignator: BranchDesignator.InHome,
			ReggieMSAppointmentID: null,
			ClinicianVideoVisitJoinURL: null,
		},
		encounterGuid: '71A5FD37-70E1-4154-8C5D-FAEFFCB6DA36',
		dexp: {
			encounterGuid: '71A5FD37-70E1-4154-8C5D-FAEFFCB6DA36',
			codeNext: CodeNext.NotStarted,
			branchGuid: '74D1CB4B-F3C2-49F5-A971-DC9083084B5A',
			branchDesignator: BranchDesignator.InHome,
			dateOfService: '2025-08-09',
			memberAge: 57,
			clientName: 'XYZ Insurance Co.',
			lastUpdateDt: null,
			auditorUsername: null,
			lineOfBusiness: 'N/A',
		},
	},
	{
		type: WorkItemType.Appointment,
		status: DashboardLoadItemStatus.Error,
		item: {
			WorkItemType: WorkItemType.Appointment,
			ServiceAppointmentID: '0002',
			AppointmentNumber: 'SA-0002',
			MemberGUID: '553181D1-2765-492C-93B7-4A5D77DBECF6',
			MemberName: 'Shoomoo Hippyhair',
			MemberPhones: [],
			StartTime: '2024-02-22T20:15:00.000Z',
			EndTime: '2024-02-22T21:15:00.000Z',
			Street: '430 S Western Ave',
			City: 'Los Angeles',
			State: 'CA',
			PostalCode: '90020',
			Country: 'United States',
			Latitude: 34.06617,
			Longitude: -118.30880,
			EstimatedTravelTimeMins: 15,
			CanTrustGPS: false,
			Status: ServiceAppointmentStatus.Dispatched,
			IsJoinable: true,
			HasInterpreter: false,
			InterpreterNumber: null,
			ClinicianNotes: null,
			EligibleLabs: ['LAB1', 'LAB2'],
			BranchDesignator: BranchDesignator.VideoVisit,
			ReggieMSAppointmentID: null,
			ClinicianVideoVisitJoinURL: null,
		},
		error: serializeFusionError('test error', 'test error 123'),
		dexp: {
			encounterGuid: '26880A30-D82A-4C8D-B9DB-729CE13C5AB9',
			codeNext: CodeNext.InProgress,
			branchGuid: '74D1CB4B-F3C2-49F5-A971-DC9083084B5A',
			branchDesignator: BranchDesignator.VideoVisit,
			dateOfService: '2025-08-09',
			memberAge: 83,
			clientName: 'XYZ Insurance Co.',
			lastUpdateDt: '2025-08-09 16:41:34',
			auditorUsername: null,
			lineOfBusiness: 'N/A',
		},
	},
]
